import { render, staticRenderFns } from "./NominaTabs.vue?vue&type=template&id=2704c168&"
import script from "./NominaTabs.vue?vue&type=script&lang=js&"
export * from "./NominaTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports